// utils/localStorage.js
import CryptoJS from 'crypto-js';

const ENCRYPTION_KEY = '92e7fa0e0a7bac280a7b8bd420ca4ab8f09b6aa8b1b02fe109779ab832b7a639'; //AguaHMIUI!@#11551

// Function to set an encrypted item in local storage
export const setLoginEncryptedLocalStorage = (data) => {
  try {
    const encryptedUser = CryptoJS.AES.encrypt(JSON.stringify(data.data), ENCRYPTION_KEY).toString();
    localStorage.setItem(`hmi-user`, encryptedUser);

    const encryptedToken = CryptoJS.AES.encrypt(JSON.stringify(data.token), ENCRYPTION_KEY).toString();
    localStorage.setItem(`hmi-token`, encryptedToken);
  } catch (error) {
    console.error('Error setting encrypted local storage:', error);
  }
};

// Function to set an encrypted item in local storage
export const removeLoginEncryptedLocalStorage = () => {
  try {
    localStorage.removeItem('hmi-user');
    localStorage.removeItem('hmi-token');
  } catch (error) {
    console.error('Error setting encrypted local storage:', error);
  }
};

// Function to set an encrypted item in local storage
export const setEncryptedLocalStorageItem = (key, value) => {
  try {
    const encryptedValue = CryptoJS.AES.encrypt(JSON.stringify(value), ENCRYPTION_KEY).toString();
    localStorage.setItem(`hmi-${key}`, encryptedValue);
  } catch (error) {
    console.error('Error setting encrypted local storage:', error);
  }
};

// Function to get an encrypted item from local storage
export const getEncryptedLocalStorageItem = (key) => {
  try {
    const encryptedValue = localStorage.getItem(`hmi-${key}`);
    if (encryptedValue) {
      const bytes = CryptoJS.AES.decrypt(encryptedValue, ENCRYPTION_KEY);
      const decryptedValue = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      return decryptedValue;
    }
    return null;
  } catch (error) {
    console.error('Error getting encrypted local storage:', error);
    return null;
  }
};

// Function to remove an encrypted item from local storage
export const removeEncryptedLocalStorageItem = (key) => {
  try {
    localStorage.removeItem(`hmi-${key}`);
  } catch (error) {
    console.error('Error removing encrypted local storage:', error);
  }
};


// Function to remove an encrypted item from local storage
export const checkEncryptedLocalStorageItem = () => {
  try {
    return localStorage.getItem('hmi-token') !== null;
  } catch (error) {
    console.error('Error removing encrypted local storage:', error);
    return false;
  }
};